import React, { useState } from "react";
import { Checkbox, Tooltip } from "antd";
import moment from "moment";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openEinvoicePreview, openPreviewNew } from "../../../store/actions/detailsDocument/preview";
import PreviewDocumentModal from "../detail/previewDocumentModal";
import { startDownloadData } from "../../../libs/utils";
import { resetDownloadDocument } from "../../../store/actions/download";

const InvoiceBlock = ({allWidth, data, hideCheckbox, selectedDocuments, setSelectedDocuments, allDocumentsSelected, index}) => {
  const intl = useIntl();
  const [isChecked, setIsChecked] = useState(false);
  const [isAccordionDescriptionVisible, setIsAccordionDescriptionVisible] = useState(false);
  const [isAccordionDescriptionActive, setIsAccordionDescriptionActive] = useState(false);
  const [ previewModal, setPreviewModal] = useState(false);
  const [einvoiceType, setEinvoiceType] = useState("ASSOSW");
  const download = useSelector(state => state.download);
  const [currentIndex, setCurrentIndex] = useState(null);

  useEffect(() => {
    setIsChecked(allDocumentsSelected ? true : false);
  }, [allDocumentsSelected]);

  useEffect(() => {
    setIsAccordionDescriptionVisible(data?.doc?.description?.length > 150 ? true : false);
  }, [data]);

  const dispatch = useDispatch();

  useEffect(() => {    
    // vale solo per le fatture elettroniche che hanno 3 modalità di visualizzazioni
    if (!data?.doc?.id || !previewModal) return;
    dispatch(openEinvoicePreview(data?.doc.id, einvoiceType));
  }, [data, einvoiceType]);

  useEffect(() => {
    if (!download.status.ended || !download.content) return;
    if (index === currentIndex) {
      startDownloadData(download);
      dispatch(resetDownloadDocument());
      setCurrentIndex(null);
    }
  }, [download]);

  const openPreview = (documentId, factType) => {
    /**
     * La preview viene gestita come segue:
     * factType === INVOICE | RECEIPT -> si chiama la preview del b2b-read
     * factType === BANK_TRANSACTION -> nessuna preview
     * factType === DOCUMENT -> preview pdc-server-api
     */
    setPreviewModal(true);
    if (factType === "INVOICE" || factType === "RECEIPT"){
      dispatch(openEinvoicePreview(documentId, "ASSOSW")).then(res => {
        if (res) {

        }
      }).catch( err => {
        console.log("Error preview");
      });

    } else if (factType === "DOCUMENT"){
      dispatch(openPreviewNew(
        documentId,
        1,
        false
      )).then(res => {
        if (res) {
          setPreviewModal(true);
        }
      }).catch( err => {
        console.log("Error preview");
      });
    }
  };

  const checkedConditions = id => {
    if (allDocumentsSelected && isChecked && selectedDocuments.includes(id)) {
      return true;
    } else if (allDocumentsSelected && !isChecked) {
      return false;
    } else if (!allDocumentsSelected && isChecked && selectedDocuments.includes(id)){
      return true;
    } 
    return false;
    
  };

  const renderTooltipText = () => {
    return (
      <div className="container">
        <b className="title">{data?.doc?.reverseCharge?.type}</b>
        <span className="description"> {data?.doc?.reverseCharge?.description}</span>
      </div>
    );
  };

  const onCheckDocument = id => {
    setIsChecked(!isChecked);
    const selectedDocumentsCopy = [...selectedDocuments];
    if (selectedDocumentsCopy.includes(id)){
      const newSelectedDocuments = selectedDocumentsCopy.filter(x => x !== id);
      setSelectedDocuments([...newSelectedDocuments]);
    } else {
      setSelectedDocuments([...selectedDocuments, id]);
    }
  };

  return (
    <>
      <div className={`precog-invoice-block-container ${allWidth ? "fullWidth" : ""}`}>
        <div className="precog-invoice-block-row">
          <div className="precog-invoice-block-inv-first-part">
            <div className="precog-invoice-block-inv-description">
              <div className="desc-row">
                
                { !hideCheckbox ? 
                  <Tooltip 
                    color={"rgb(0, 80, 117)"}
                    placement="right" title={data?.draftStatus?.messageCode ? intl.formatMessage({id: `preCog.draftStatusMessage.${data?.draftStatus?.messageCode}`, defaultMessage: data?.draftStatus?.message}) : null}>
                    <Checkbox checked={checkedConditions(data?.id)} onChange={() => onCheckDocument(data?.id)}
                      disabled={!data?.draftStatus?.isConfirmable} 
                    >               
                      <b className="title"> 
                        {data?.doc.source === "MANUAL" &&  (["PF1", "RF1", "PAF1", "RAC1" ].includes(data?.reasonId)) ? "Movimenti finanziari" 
                          :  data?.doc.source === "MANUAL" && (["CG1", "RG1", "MG1"].includes(data?.reasonId)) ? "Altri movimenti"
                            :
                            data?.reasonId === "GD" ? "Nuovo documento" : data?.doc?.factType === "INVOICE" ?
                              `Fattura di ${data?.doc?.active ? "vendita" : "acquisto"}`  
                              : data?.doc?.factType === "RECEIPT" ?
                                <FormattedMessage id="preCog.accountingTab.receiptType"/>
                                : "Movimento bancario"
                        }
                      </b>
                    </Checkbox>
                  </Tooltip>
                  :
                  <b className="title"> 
                    {(data?.doc?.source || data?.source) === "MANUAL" &&  (["PF1", "RF1", "PAF1", "RAC1"].includes(data?.reasonId)) ? "Movimenti finanziari" 
                      :  data?.doc?.source === "MANUAL" && (["CG1", "RG1", "MG1"].includes(data?.reasonId)) ? "Altri movimenti"
                        :
                        data?.reasonId === "GD" ? "Nuovo documento" : data?.doc?.factType === "INVOICE" ?
                          `Fattura di ${data?.doc?.active ? "vendita" : "acquisto"}`  
                          : data?.doc?.factType === "RECEIPT" ?
                            <FormattedMessage id="preCog.accountingTab.receiptType"/>
                            : "Movimento bancario"
                    }
                  </b>
                }
                {data?.doc?.factType !== "BANK_TRANSACTION" && data?.doc?.source === "B2B" && data?.doc?.id &&
                    <div onClick={() => openPreview(data?.doc?.id, data?.doc?.factType)}
                      style={{ display: "flex", alignItems: "center", padding: "0 16px", cursor: "pointer" }}>
                      <FontAwesomeIcon icon={["far", "eye"]} className="invoice-block-eye-icon"/>
                    </div>
                }
              </div>
              <div className="desc-row">
                <span className={`description ${(isAccordionDescriptionVisible && !isAccordionDescriptionActive) && "mov-desc-truncated"}`} style={{marginLeft: `${hideCheckbox ? 0 : "25px"}`, marginRight: data?.doc?.factType === "BANK_TRANSACTION" && "20px", height: data?.doc?.factType === "BANK_TRANSACTION" && "auto", maxWidth: "220px" }}> 
                  {data?.doc?.factType !== "BANK_TRANSACTION" ?
                    `n. ${data?.doc?.number} del ${moment(data?.doc?.date).format("DD/MM/YYYY")}`
                    : data?.doc?.description
                  }
                </span>
              </div>
              {data?.doc?.factType === "BANK_TRANSACTION" && isAccordionDescriptionVisible &&
              <div className="dashboard-movement-accordion-container"> 
                <FontAwesomeIcon
                  onClick={() => setIsAccordionDescriptionActive(!isAccordionDescriptionActive)}
                  icon={!isAccordionDescriptionActive ? ["far", "angle-down"] : ["far", "angle-up"]}
                  style={{
                    color: "rgb(0, 144, 209)",
                    margin: "-4px 10px 0 0",
                    fontSize: "20px",
                    cursor: "pointer"
                  }}
                />
              </div>
              }
            </div>
            <div className="precog-invoice-block-inv-receipt">
              <div className="block-inv-receipt-title-container">
                <b className="title"> 
                  <FormattedMessage id={"preCog.accountingTab.receipt"}/> 
                </b>
              </div>
              <div className="receipt-desc-container">
                {data?.doc?.factType !== "BANK_TRANSACTION" ?
                  data?.doc?.source === "B2B" ?
                    <span className="receipt-content"><FormattedMessage id="preCog.accountingTab.sdi"/></span>
                    : (
                      <div className="receipt-content">
                        <FontAwesomeIcon icon={["far", "upload"]} style={{color: "#0090d1"}}/>
                      </div>
                    )
                  : data?.doc?.source === "MANUAL" && (["MG1", "PF1", "RF1", "PAF1", "RAC1", "CG1","RG1"].includes(data?.reasonId)
                  ) ? 
                    <FontAwesomeIcon
                      style={{color: "#0090d1", margin: "5px 10px 0 0"}}
                      icon={["far", "upload"]}
                    />
                    :
                    <FontAwesomeIcon
                      style={{color: "#0090d1", margin: "5px 10px 0 0"}}
                      icon={["far", "university"]}
                    />
                }
           
                {data?.doc?.factType !== "BANK_TRANSACTION" ?
                  !data?.doc?.active &&
                  <span className="description">{moment(data?.doc?.date).format("DD/MM/YYYY")}</span>
                  : (data?.doc?.factType === "BANK_TRANSACTION" && data?.doc?.source === "MANUAL" && (["PF1", "RF1", "PAF1", "RAC1", "CG1", "RG1"].includes(data?.reasonId)
                  )) ?
                    <span className="description">{data?.doc?.date ? moment(data?.doc?.date).format("DD/MM/YYYY") : "/"}</span>
                    : null
                }
              </div>
            </div>
          </div>
          {data?.reasonId !== "GD" && <div className="precog-invoice-block-inv-second-part">
            <div className="amount-block">
              <div style={{display: "flex"}}>
                <b>{numeral(Math.abs(data?.amount)).format("0,0.00")} €</b>
              </div>
              <span className="amount-description"><FormattedMessage id="preCog.accountingTab.amountDescription"/></span>
            </div>
          </div>}
        </div>
        {data?.doc?.factType === "BANK_TRANSACTION" && !(data?.doc.source === "MANUAL" && (["PF1", "RF1", "PAF1", "MG1", "RAC1", "CG1", "RG1"].includes(data?.reasonId)
        )) &&
      <div 
        className={"movement-description-container"}>        
        <div className={`movement-description-section ${hideCheckbox ? "noMargin" : ""}`}>                
          <b className="title"> 
            <FormattedMessage id={"preCog.accountingTab.movementDate"}/> 
          </b>
          <Tooltip 
            color={"rgb(0, 80, 117)"}
            placement="top">
            <FontAwesomeIcon
              icon={["fas", "info-circle"]}
              style={{color: "#0090d1", marginTop: "2px"}}
            />
          </Tooltip>
        </div>
        <div className={`movement-description-section ${hideCheckbox ? "noMargin" : ""}`}>
          <span className="description">{data?.doc?.date ? moment(data?.doc?.date).format("DD/MM/YYYY") : "/"}</span>
        </div>
      </div>
        }
        {data?.reasonId !== "GD" && <div className="precog-invoice-block-row">
          <div className={`issuer-section ${hideCheckbox ? "noMargin" : ""}`}>
            <b className="title" style={{display: (data?.doc?.factType === "BANK_TRANSACTION" && !data?.doc?.company) && "none" }}>
              <FormattedMessage id={
                ((data?.doc?.active && data?.doc?.factType !== "BANK_TRANSACTION") || (data?.doc?.active && data?.doc.source === "MANUAL" && (["PF1", "RF1", "PAF1", "RAC1", "CG1", "RG1"].includes(data?.reasonId) 
                ))) ? "preCog.accountingTab.client" : 
                  ((!data?.doc?.active && data?.doc?.factType !== "BANK_TRANSACTION") || (!data?.doc?.active && data?.doc.source === "MANUAL" && (["PF1", "RF1", "PAF1", "RAC1", "CG1", "RG1"].includes(data?.reasonId) 
                  ))) ? "preCog.accountingTab.supplier" : 
                    (!data?.doc?.active && data?.doc?.factType === "BANK_TRANSACTION") ? "preCog.accountingTab.beneficiary" 
                      : "preCog.accountingTab.orderer" 
              }/>
            </b>
            <span className="description" style={{textTransform: "capitalize"}}>{data?.customerName?.toLowerCase()  || data?.doc?.company?.toLowerCase()} </span>
          </div>
        </div>}
        {data?.reasonId !== "GD" && <div className="precog-invoice-block-row">
          <div className={`vat-collectability-section ${hideCheckbox ? "noMargin" : ""}`}>          
            <div className="vat-collectability-container" style={{display: data?.doc?.factType === "BANK_TRANSACTION" && "none"}}>
              <div className="vat-collectability">
                <div className="vat-collectability-title-container">
                  <b className="title"><FormattedMessage id={data?.doc?.factType !== "BANK_TRANSACTION" ? "preCog.accountingTab.collectability" : "preCog.accountingTab.invoicesRef"}/></b>
                  {data?.doc?.factType === "BANK_TRANSACTION" &&
                  <Tooltip 
                    color={"rgb(0, 80, 117)"}
                    placement="top">
                    <FontAwesomeIcon
                      icon={["fas", "info-circle"]}
                      style={{color: "#0090d1", marginTop: "2px"}}
                    />
                  </Tooltip>
                  }
                </div>
                <span className="description" style={{textTransform: data?.doc?.factType !== "BANK_TRANSACTION" && "capitalize"}}>
                  { data?.doc?.factType !== "BANK_TRANSACTION" ?
                    <FormattedMessage id={`preCog.header.${data?.vatCollectability}`} />
                    :  `n. ${data?.doc?.number ? data?.doc?.number : "N/A" } del ${moment(data?.doc?.date).format("DD/MM/YYYY")}`
                  }
                </span>
              </div>
              {data?.doc?.reverseCharge &&
              <div className="reverse-charge">
                <b className="title" style={{ marginRight: "10px" }}><FormattedMessage id="preCog.accountingTab.reverseCharge" /></b>
                <Tooltip placement="top" title={renderTooltipText()} color={"white"} overlayClassName="precog-reverse-charge-tooltip-container">
                  <FontAwesomeIcon
                    icon={["fas", "info-circle"]}
                    className={"reverse-info-icon"}
                    style={{ color: "#0090d1", marginTop: "2px" }}
                  />
                </Tooltip>
              </div>
              }
            </div>
          </div>
        </div>}
        <PreviewDocumentModal isImage={data?.doc?.factType === "DOCUMENT"} previewModal={previewModal}
          einvoiceType={einvoiceType} setEinvoiceType={setEinvoiceType}
          setPreviewModal={setPreviewModal} data={data} isDashboard={true} setCurrentIndex={setCurrentIndex} index={index} />
      </div>
    </>
  );
};

export default InvoiceBlock;
